import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

const NAV_ITEMS = [
    { icon: '🏠', label: 'Base Camp', to: '/dashboard' },
    { icon: '⚔️', label: 'Quests', to: '/courses' },
    { icon: '🏆', label: 'Rankings', to: '/leaderboard' },
    { icon: '🎮', label: 'Player Card', to: '/profile' },
];

export default function Sidebar() {
    return (
        <aside className="hidden md:flex fixed left-0 top-16 bottom-0 w-64 flex-col bg-game-surface border-r border-white/5 z-[90]">
            <nav className="flex-1 py-4 px-3 flex flex-col gap-1 overflow-y-auto">
                {NAV_ITEMS.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={({ isActive }) => cn(
                            'flex items-center gap-3 px-4 py-3 rounded-xl font-heading font-black text-xs uppercase tracking-widest transition-all duration-200',
                            isActive
                                ? 'bg-game-primary/15 text-game-primary-l border border-game-primary/25 shadow-[0_0_12px_rgba(124,58,237,0.15)]'
                                : 'text-game-muted hover:text-game-text hover:bg-white/5 border border-transparent'
                        )}
                    >
                        <span className="text-lg leading-none w-6 text-center">{item.icon}</span>
                        <span>{item.label}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="px-3 py-4 border-t border-white/5">
                <NavLink
                    to="/settings"
                    className={({ isActive }) => cn(
                        'flex items-center gap-3 px-4 py-3 rounded-xl font-heading font-black text-xs uppercase tracking-widest transition-all duration-200',
                        isActive
                            ? 'bg-game-primary/15 text-game-primary-l border border-game-primary/25'
                            : 'text-game-dim hover:text-game-muted hover:bg-white/5 border border-transparent'
                    )}
                >
                    <span className="text-lg leading-none w-6 text-center">⚙️</span>
                    <span>Settings</span>
                </NavLink>
            </div>
        </aside>
    );
}
